import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';

import { InteractionsService } from '@offconon/core-api';
import { UserService } from '@offconon/user-api';

import * as UserActions from './user.actions';
import { selectUserList } from './user.selectors';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);
  private userService = inject(UserService);
  private interactionService = inject(InteractionsService);
  private store = inject(Store);

  fetchUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.fetchUserList),
      switchMap((action) => {
        return this.interactionService
          .interactionsCommonSearchUserAndBusinessList(
            action.page,
            action.pageSize,
            action.searchJson,
          )
          .pipe(
            switchMap((users) => {
              return of(
                UserActions.onSuccessfullyFetchedUserList({
                  userList: users.results
                    ?.filter((res) => res.type === 'user')
                    .map((res) => {
                      return res.user_profile;
                    }) as any,
                }),
              );
            }),
            catchError((error) => of(UserActions.loadUserFailure({ error }))),
          );
      }),
    ),
  );

  fetchUserById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.fetchUserById),
      withLatestFrom(this.store.select(selectUserList)),

      filter(([action, users]) => !users.find((user) => user.user_id === action.id)),
      mergeMap(([action]) => {
        return this.interactionService
          .interactionsCommonSearchUserAndBusinessList(1, 1, { id: action.id })
          .pipe(
            switchMap((users) => {
              return of(
                UserActions.onSuccessfullyFetchedUserList({
                  userList: users.results
                    ?.filter((res) => res.type === 'user')
                    .map((res) => {
                      return res.user_profile;
                    }) as any,
                }),
              );
            }),
            catchError((error) => of(UserActions.loadUserFailure({ error }))),
          );
      }),
    ),
  );
}
